export const variantKey = {
  MYORDER: 'myOrder',
  ALLORDER: 'allOrder',
};
